import React, { useEffect } from 'react';
import { View, StyleSheet, Text } from 'react-native';
import { padding, scaleW } from '@/common/style';
import PlayIcon from '@/assets/icon/playIcon.png';
import { $k18n } from '@/common/i18n';
import ArrowRight from '../ArrowRight';
import { vIf } from '@/common/utils/vIf';
import { jumpToBuyerGallery } from '@/common/biz/jump';
import { logShowGalleryLine, logClickGalleryLine } from '../../../logger2.0';
import { useQuerys } from '@/hooks/useQuery';
import Image from '@kds/image';
import { useDetailPageStore } from '@/page/detail/store';
import { IShowCase } from '../../../api';
import { SCENE } from '@/common/const';
import { useExtParamsObject, useGetSellerParams } from '../../utils';
import { KTouchableOpacity } from '@/component/RtlLayout/Touchable';
import { ViewVisible } from '@/component/ViewVisible/ViewVisible';

const style = StyleSheet.create({
    container: {
        ...padding(scaleW(16), scaleW(19)),
        backgroundColor: '#fff',
        marginBottom: scaleW(8),
    },
    header: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: scaleW(12),
    },
    title: {
        color: '#000',
        fontSize: scaleW(15),
        fontWeight: '500',
    },
    text: {
        marginTop: scaleW(10),
        color: '#000',
        fontSize: scaleW(14),
        lineHeight: scaleW(21),
    },
    image: {
        width: scaleW(88),
        height: scaleW(88),
        borderRadius: scaleW(8),
        marginRight: scaleW(8),
    },
    playIcon: {
        width: scaleW(24),
        height: scaleW(24),
        position: 'absolute',
        top: scaleW(32),
        left: scaleW(32),
    },
    lastImage: {
        width: scaleW(88),
        height: scaleW(88),
        borderRadius: scaleW(8),
    },
    imageContainer: {
        flexDirection: 'row',
        alignItems: 'center',
    },
});

const CommentLine = (props: { hasBottomMargin?: boolean }) => {
    const { hasBottomMargin = true } = props;
    const pageRawData = useDetailPageStore(s => s.pageRawData);
    const galleryImgList = useDetailPageStore(s => s.galleryImgList);
    const showGalleryType = useDetailPageStore(s => s.showGalleryType);
    const galleryTotal = useDetailPageStore(s => s.galleryTotal);

    const itemId = +pageRawData?.itemId || 0;

    const { scene } = useQuerys();
    const { sellerMerchantId, sellerUserId } = useGetSellerParams();
    const extParams = useExtParamsObject();

    const videoLength = galleryImgList.length;
    const _galleryImgList = galleryImgList.slice(0, 4);

    const onClickHeader = () => {
        logClickGalleryLine(_galleryImgList?.length);
        jumpToBuyerGallery({
            extParams,
            sellerMerchantId,
            sellerUserId,
            itemId,
            scene: scene || SCENE.DEFAULT_SCENE,
            showGalleryType: (showGalleryType || [])?.join('-'),
        });
    };

    const renderCover = (item: IShowCase, index: number) => {
        if (item.photoId) {
            const videoInfo = JSON.parse(item?.photoFeedViewJson || '{}');
            const fallBackImg = 'https://cdn-static.kwai.net/kos/s101/nlav11312/kwr/ui/assets/defaultimg.b606c7d7e784c291.png';
            let coverUri = '';
            if (videoInfo?.ext_params?.mtype === 6) {
                coverUri = videoInfo?.cover_thumbnail_urls?.[0]?.url || fallBackImg;
            } else if (videoInfo?.type === 25) {
                coverUri = videoInfo?.gallery?.picture_url_list?.[0]?.[0]?.url || fallBackImg;
            } else if (videoInfo?.ext_params?.mtype !== 6 && videoInfo?.type !== 25) {
                coverUri = videoInfo?.cover_thumbnail_urls?.[0]?.url;
            }
            return (
                <>
                    <Image style={videoLength === index - 1 ? style.lastImage : style.image} source={{ uri: coverUri }} resizeMethod="resize" />
                    <Image style={style.playIcon} source={PlayIcon} resizeMethod="resize" />
                </>
            );
        }
        // 优先展示视频
        if (item.videoInfo?.[0]) {
            return (
                <>
                    <Image
                        style={videoLength === index - 1 ? style.lastImage : style.image}
                        source={{ uri: item.videoInfo[0].videoCoverUrl }}
                        resizeMethod="resize"
                    />
                    <Image style={style.playIcon} source={PlayIcon} resizeMethod="resize" />
                </>
            );
        }
        return <Image style={videoLength === index - 1 ? style.lastImage : style.image} source={{ uri: item.imageUrl[0] }} resizeMethod="resize" />;
    };

    const onGalleryShow = () => {
        logShowGalleryLine(_galleryImgList?.length);
    };

    return (
        <ViewVisible rootMargin={{ top: 0, left: 0, right: 0, bottom: 100 }} onVisible={onGalleryShow}>
            <View style={[style.container, !hasBottomMargin ? { marginBottom: 0 } : null]}>
                <KTouchableOpacity activeOpacity={0.6} onPress={onClickHeader}>
                    <View style={style.header}>
                        <Text style={style.title}>
                            {$k18n({ text: '买家秀', id: 'k_1226109' })}
                            {vIf(Boolean(galleryTotal), ` (${galleryTotal})`)}
                        </Text>
                        <ArrowRight />
                    </View>
                    <View
                        style={{"marginTop":"0rem"}}>
                        {videoLength ? (
                            <>
                                <KTouchableOpacity activeOpacity={0.6} onPress={onClickHeader}>
                                    <View style={style.imageContainer}>
                                        {_galleryImgList.map((item: IShowCase, index) => (
                                            <View style={{"position":"relative"}}>{renderCover(item, index)}</View>
                                        ))}
                                    </View>
                                </KTouchableOpacity>
                            </>
                        ) : null}
                    </View>
                </KTouchableOpacity>
                <View
                    style={{"height":"0.24154589371980678rem","width":"90.33816425120774rem","backgroundColor":"rgba(242, 242, 242, 1)","position":"absolute","bottom":"0rem","left":"4.830917874396135rem"}}
                />
            </View>
        </ViewVisible>
    );
};

export default CommentLine;
